import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { api } from 'api';
import style from './notice.module.scss';
import { TongyongGuanbiMian, TongyongGuanbiXian } from '@sirius/icons';
const dataStoreApi = api.getDataStoreApi();
const systemApi = api.getSystemApi();
const isWeb = !systemApi.isElectron();
const isWmWeb = systemApi.isWebWmEntry();
const KEY = 'emdNotice';
export const Notice = ({ notice, className }) => {
    const [showTip, setShowTip] = useState(true);
    useEffect(() => {
        if (!notice) {
            return;
        }
        dataStoreApi.get(KEY).then(({ data }) => {
            if (!data) {
                setShowTip(true);
            }
            try {
                const json = JSON.parse(data);
                if (json) {
                    return setShowTip(json[notice.id] !== false);
                }
            }
            catch (e) {
                setShowTip(true);
            }
        });
    }, [notice]);
    const closeThisNotice = () => {
        setShowTip(false);
        if (notice) {
            dataStoreApi.get(KEY).then(({ data }) => {
                let map = {};
                try {
                    if (data) {
                        map = JSON.parse(data) || {};
                    }
                }
                finally {
                    map[notice.id] = false;
                    dataStoreApi.putSync(KEY, JSON.stringify(map), {
                        noneUserRelated: false,
                    });
                }
            });
        }
    };
    if (!showTip || !notice) {
        return null;
    }
    return (React.createElement("div", { className: classnames(style.alertInfo, className, {
            [style.isWeb]: isWeb,
            [style.isWmWeb]: isWmWeb,
        }) },
        React.createElement("span", { className: style.icon },
            React.createElement(TongyongGuanbiMian, { className: style.infoIcon, wrapClassName: style.wrapIcon })),
        React.createElement("span", { className: style.infoContent }, notice === null || notice === void 0 ? void 0 : notice.content),
        (notice === null || notice === void 0 ? void 0 : notice.closeable) && (React.createElement("span", { className: classnames('sirius-no-drag', style.closeIconWrapper), onClick: closeThisNotice },
            React.createElement(TongyongGuanbiXian, { className: style.closeIcon, wrapClassName: style.wrapCloseIcon })))));
};
